module.exports = __webpack_public_path__ + "img/transparent_vue.39faba29.png";